import { combineReducers } from "redux";
import { UpdateReducer } from "./UpdateReducer";

const rootReducer = combineReducers({
    update: UpdateReducer,
})

export default rootReducer